<template>
    <div class="con">
        <div class="item flx alc">
            <div class="itemLeft">
                账号密码
            </div>
            <div class="itemMiddle">
                如您需要更改当前账号密码，请点击【修改密码】
            </div>
            <el-button type="primary" @click="show1 = true">修改密码</el-button>
        </div>

        <div class="item flx alc">
            <div class="itemLeft">
                账号注销
            </div>
            <div class="itemMiddle">
                账号注销后，您的账号将会永久失效且不可恢复，视为自动放弃部分权限和服务。请谨慎操作！
            </div>
            <el-button type="primary" @click="delacc">注销账号</el-button>
        </div>

        <div class="item flx alc">
            <div class="itemLeft">
                绑定手机
            </div>
            <div class="itemMiddle">
                当前账号绑定手机号为: {{tel}}
            </div>
            <el-button type="primary" @click="show = true">修改手机</el-button>
        </div>
        
        <div class="item flx alc" @click="logout">
            <div class="itemLeft">
                退出登录
            </div>
            <div class="itemMiddle">
                退出当前登录账号
            </div>
            <el-button type="primary">退出账号</el-button>
        </div>
        
        <!-- 修改手机号弹窗 -->
        <changePhone v-if="show" @cal="refreshInfo"></changePhone>
        <!-- 修改密码弹窗 -->
        <changePwd v-if="show1" @cal="refreshInfo"></changePwd>
    </div>
</template>

<script>
    import {
        delAccount,
        userInfo
    } from "@/api/index.js"
    import changePhone from "@/components/changePhoneNumber.vue"
    import changePwd from "@/components/changePwd.vue"
    export default {
        components: {
            changePhone,
            changePwd
        },
        data() {
            return {
                tel:"",
                show:false,
                show1:false
            }
        },
        created() {
            this.refreshInfo()
        },
        methods: {
            logout(){
                localStorage.removeItem('token')
                localStorage.removeItem('user_id')
                window.location.href = "https://hrxsl.com/"
            },
            hidePhone(phone) {
              if (!phone || phone.length !== 11) return phone;
              return phone.slice(0, 3) + '****' + phone.slice(7);
            },
            refreshInfo(){
                let that = this 
                that.show = false
                that.show1 = false
                userInfo().then((res) => {
                    if(res.code == 1){
                        that.tel = that.hidePhone(res.data.tel)
                    }else{
                        that.$message.error(res.msg)
                        return
                    }
                })
            },
            delacc() {
                let that = this
                that.$confirm('确定要注销该账号吗?', '友情提醒 ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delAccount().then((res) => {
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            localStorage.removeItem('token')
                            localStorage.removeItem('user_id')
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
        }
    }
</script>

<style scoped>
    .item {
        margin-bottom: 24px;
    }

    .con {
        box-sizing: border-box;
        padding: 40px 30px;
    }

    .itemLeft {
        font-weight: 500;
        font-size: 14px;
        color: #3A3D4B;
        margin-right: 14px;
    }

    .itemMiddle {
        width: 639px;
        height: 42px;
        border-radius: 6px;
        border: 1px solid #D9D9D9;
        line-height: 42px;
        font-size: 14px;
        margin-right: 30px;
        text-align: left;
        box-sizing: border-box;
        padding: 0 12px;
    }
</style>